module.exports = __webpack_public_path__ + "static/media/logo.0ac6e5b0.png";